import {FC} from "react";
import {useQueryResultContext} from "@constructor/components/features/queries/context";
import {Text} from "@constructor/components";
import {getNestedValue} from "@/helpers/utils";

interface QueryFieldProps {
    field: string;
}

const QueryField: FC<QueryFieldProps> = ({field, ...props}) => {
    const result = useQueryResultContext();


    if(!result?.result) {
        return null;
    }

    const value = getNestedValue(result.result, field);
    console.log(value);
    return (
        <Text text={value} {...props} replaces={{message: value}} />
    )
}

export default QueryField;